module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "txc",
    attrs: {
      "id": "d12e33"
    }
  }, [_c('b', [_vm._v("Other Books by Gilbert Morris")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "d12e36"
    }
  }, [_c('i', [_vm._v("Charade")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "d12e39"
    }
  }, [_c('i', [_vm._v("Jacob’s Way")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "d12e42"
    }
  }, [_c('i', [_vm._v("Edge of Honor")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "d12e45"
    }
  }, [_c('i', [_vm._v("Jordan’s Star")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "d12e48"
    }
  }, [_c('i', [_vm._v("God’s Handmaiden")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "d12e51"
    }
  }, [_c('i', [_vm._v("The Spider Catcher")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "d12e54"
    }
  }, [_c('b', [_vm._v("The Singing River Series")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "d12e57"
    }
  }, [_c('i', [_vm._v("The Homeplace")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "d12e60"
    }
  }, [_c('i', [_vm._v("The Dream")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "d12e63"
    }
  }, [_c('i', [_vm._v("The Miracle")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c42d9b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Morr_9780310252344_epub_c1a_r1.vue
// module id = 60
// module chunks = 0